import {
    DOUBLE_TAP_MS,
    DOUBLE_TAP_RESET_RATIO,
    DOUBLE_TAP_SLOP,
    DOUBLE_TAP_ZOOM_FACTOR,
    PAGE_SIDE_PADDING,
} from '../constants';
import { FitMode } from '../types';

const HALF = 2;

export interface Point {
    x: number;
    y: number;
}

export interface Tap extends Point {
    time: number;
}

export const distance = (a: Point, b: Point): number => Math.hypot(a.x - b.x, a.y - b.y);

export const midpoint = (a: Point, b: Point): Point => ({ x: (a.x + b.x) / HALF, y: (a.y + b.y) / HALF });

export const pinchZoom = (startZoom: number, startDistance: number, currentDistance: number): number => (
    startDistance > 0 ? startZoom * (currentDistance / startDistance) : startZoom
);

export const isDoubleTap = (previous: Tap | null, current: Tap): boolean => (
    previous !== null
    && current.time - previous.time <= DOUBLE_TAP_MS
    && distance(previous, current) <= DOUBLE_TAP_SLOP
);

export const doubleTapTarget = (zoom: number, fitWidthZoom: number): number => (
    zoom > fitWidthZoom * DOUBLE_TAP_RESET_RATIO ? fitWidthZoom : fitWidthZoom * DOUBLE_TAP_ZOOM_FACTOR
);

export const initialFitMode = (isNarrow: boolean): FitMode => (isNarrow ? 'width' : 'page');

export interface AnchoredScrollLeftInput {
    scrollLeft: number;
    anchorX: number;
    clientWidth: number;
    pageWidth: number;
    oldZoom: number;
    newZoom: number;
}

const pageLeft = (clientWidth: number, pageWidth: number, zoom: number): number => (
    Math.max(PAGE_SIDE_PADDING, (clientWidth - pageWidth * zoom) / HALF)
);

export const anchoredScrollLeft = ({
    scrollLeft, anchorX, clientWidth, pageWidth, oldZoom, newZoom,
}: AnchoredScrollLeftInput): number => {
    const pointOnPage = (scrollLeft + anchorX - pageLeft(clientWidth, pageWidth, oldZoom)) / oldZoom;
    const target = pageLeft(clientWidth, pageWidth, newZoom) + pointOnPage * newZoom - anchorX;
    const maxScroll = Math.max(0, pageWidth * newZoom + PAGE_SIDE_PADDING * HALF - clientWidth);
    return Math.min(maxScroll, Math.max(0, target));
};
